

import FormLoginContainer from "./formLoginContainer";
import HeaderLoginLaptop from "./headerLoginLaptop";
import LoginPopupContainer from "./loginPopupContainer";

export default function MainSignUp() {
  return (
    <div className="">
      <HeaderLoginLaptop />
      <LoginPopupContainer /> 

    </div>
  );
}
